var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 1307.999939",
    height: 1744,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2d01882de5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 131.507812 L 1022 131.507812 L 1022 1151 L 0 1151 Z M 0 131.507812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2d01882de5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 1021.277344 639.421875 C 1021.277344 921.335938 792.554688 1150.0625 510.636719 1150.0625 C 228.722656 1150.0625 0 921.335938 0 639.421875 C 0 357.507812 228.722656 128.785156 510.636719 128.785156 C 792.554688 128.785156 1021.277344 357.507812 1021.277344 639.421875 Z M 40.851562 639.421875 C 40.851562 898.785156 251.277344 1109.210938 510.636719 1109.210938 C 770 1109.210938 980.425781 898.785156 980.425781 639.421875 C 980.425781 380.058594 770 169.636719 510.636719 169.636719 C 251.277344 169.636719 40.851562 380.058594 40.851562 639.421875 Z M 40.851562 639.421875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 510.636719 741.550781 C 386.597656 741.550781 285.957031 640.910156 285.957031 516.867188 C 285.957031 392.828125 386.597656 292.1875 510.636719 292.1875 C 634.679688 292.1875 735.320312 392.828125 735.320312 516.867188 C 735.320312 640.910156 634.679688 741.550781 510.636719 741.550781 Z M 510.636719 700.699219 C 612.128906 700.699219 694.46875 618.359375 694.46875 516.867188 C 694.46875 415.378906 612.128906 333.039062 510.636719 333.039062 C 409.148438 333.039062 326.808594 415.378906 326.808594 516.867188 C 326.808594 618.359375 409.148438 700.699219 510.636719 700.699219 Z M 510.636719 700.699219 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 367.660156 864.101562 L 653.617188 864.101562 C 748.296875 864.101562 816.171875 896.019531 858.722656 949.210938 C 865.746094 957.933594 878.722656 959.421875 887.445312 952.1875 C 896.382812 945.167969 897.660156 932.402344 890.636719 923.675781 C 840.214844 860.699219 760.636719 823.253906 653.617188 823.253906 L 367.660156 823.253906 C 260.636719 823.253906 181.0625 860.699219 130.636719 923.675781 C 123.617188 932.402344 124.894531 945.167969 133.828125 952.1875 C 142.554688 959.421875 155.53125 957.933594 162.554688 949.210938 C 205.105469 896.019531 272.980469 864.101562 367.660156 864.101562 Z M 367.660156 864.101562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAccount);
export default __webpack_public_path__ + "static/media/company_account.e0bd7e8c48dccc37c58b589bb4143749.svg";
export { ForwardRef as ReactComponent };